import { AidStation } from '../types';

export const parseAidStations = (text: string): AidStation[] => {
  const lines = text.split('\n');
  return lines
    .filter(line => line.trim())
    .map((line, index): AidStation => {
      // Extract PC number, distance, and name using regex
      const match = line.match(/PC(\d+)\s+a\s+(\d+(?:\.\d+)?)\s*km\s*(?:["'])?([^"']+)(?:["'])?/);
      if (match) {
        const [, pcNumber, distance, name] = match;
        return {
          id: `station-${pcNumber}`,
          name: name.trim(),
          distance: parseFloat(distance),
          pcNumber: parseInt(pcNumber, 10)
        };
      }
      // If no match, treat as a waypoint
      const simpleMatch = line.match(/(\d+(?:\.\d+)?)\s*(?:km\s*)?(?:["'])?([^"']+)(?:["'])?/);
      if (simpleMatch) {
        const [, distance, name] = simpleMatch;
        return {
          id: `waypoint-${index}`,
          name: name.trim(),
          distance: parseFloat(distance),
          pcNumber: 0 // Use 0 for non-PC points
        };
      }
      // Default fallback
      return {
        id: `waypoint-${index}`,
        name: `Waypoint ${index}`,
        distance: 0,
        pcNumber: 0
      };
    });
}; 